export default __webpack_public_path__ + "static/media/alert.1f98705e.png";